// Swiper initialization for Shop all categories section
let categoriesSwiper = null;
let resizeTimeout = null;
let isInitialized = false;

function initCategoriesSwiper() {
  const swiperElement = document.querySelector('.all-categories-swiper');

  if (!swiperElement) return;

  const isMobile = window.innerWidth < 768;

  if (isMobile && !categoriesSwiper) {
    // eslint-disable-next-line no-new, no-undef
    categoriesSwiper = new Swiper('.all-categories-swiper', {
      loop: true,
      spaceBetween: 16,
      slidesPerView: 2.3,
      breakpoints: {
        100: {
          slidesPerView: 1.5,
        },
        360: {
          slidesPerView: 2.3,
        },
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
      },
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
      mousewheel: {
        invert: false,
      },
    });
  } else if (!isMobile && categoriesSwiper) {
    categoriesSwiper.destroy(true, true);
    categoriesSwiper = null;
  }
}

function debouncedResize() {
  if (resizeTimeout) {
    clearTimeout(resizeTimeout);
  }

  resizeTimeout = setTimeout(() => {
    initCategoriesSwiper();
  }, 150);
}

function handleResize() {
  if (document.querySelector('.all-categories-swiper')) {
    debouncedResize();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!isInitialized) {
    initCategoriesSwiper();
    isInitialized = true;

    if (document.querySelector('.all-categories-swiper')) {
      window.addEventListener('resize', handleResize, { passive: true });
    }
  }
});

window.addEventListener('beforeunload', () => {
  if (categoriesSwiper) {
    categoriesSwiper.destroy(true, true);
    categoriesSwiper = null;
  }

  if (resizeTimeout) {
    clearTimeout(resizeTimeout);
  }

  window.removeEventListener('resize', handleResize);
});
